module.exports = __webpack_public_path__ + "img/fingerprint-two.8e18a1a6.svg";